export default __webpack_public_path__ + "static/media/warning-circle.fa876142.svg";